import React from 'react';

const BlobButton = ({ children, onClick, className = '', variant = 'default', disabled = false, type = 'button', ...props }) => {
  return (
    <button 
      type={type}
      disabled={disabled}
      className={`blob-btn ${variant === 'white' ? 'blob-btn--white' : ''} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
      <span className="blob-btn__inner">
        <span className="blob-btn__blobs">
          <span className="blob-btn__blob"></span>
          <span className="blob-btn__blob"></span>
          <span className="blob-btn__blob"></span>
          <span className="blob-btn__blob"></span>
        </span>
      </span>
    </button>
  );
};

export default BlobButton;
